/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationCredentialsRequest
 */
export interface AuthenticationCredentialsRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationCredentialsRequest
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationCredentialsRequest
     */
    password?: string | null;
}

export function AuthenticationCredentialsRequestFromJSON(json: any): AuthenticationCredentialsRequest {
    return AuthenticationCredentialsRequestFromJSONTyped(json, false);
}

export function AuthenticationCredentialsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationCredentialsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function AuthenticationCredentialsRequestToJSON(value?: AuthenticationCredentialsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

